<template>
  <v-layout>
    <v-flex xs3 sm3>
      <v-container fluid>
        <v-card class="grey lighten-3">
          <v-card-title class="headline primary white--text">
            Questions List
          </v-card-title>
          <v-card-text>
            <v-layout class="previous d-block">
              <v-list class="d-block scrollable">
                <v-list-tile
                  avatar
                  v-for="(item, i) in indexData.questions.data"
                  :key="i"
                  @click="
                    getComponent(item.project_id, item.id, item.ui_category_id)
                  "
                >
                  <v-list-tile-avatar>
                    <v-icon medium color="#11111">list</v-icon>
                  </v-list-tile-avatar>

                  <v-list-tile-content v-if="item.project_language == 2">
                    <v-list-tile-title>
                      {{ item.question_bangla }}
                    </v-list-tile-title>
                  </v-list-tile-content>
                  <v-list-tile-content v-else>
                    <v-list-tile-title>{{ item.question }}</v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
              </v-list>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-container>
    </v-flex>
    <v-flex xs9 sm9>
      <v-container fluid>
        <v-card class="grey lighten-3">
          <v-card-title class="headline primary white--text">
            <span>Response Summary Report</span>
            <v-spacer></v-spacer>
            <v-btn small color="success" @click="back">Back</v-btn>
          </v-card-title>
          <v-card-text>
            <v-layout class="previous d-block">
              <FreqTblPieBar
                :dataset.sync="dataSet"
                v-if="
                  ui_category_id == 1 ||
                  ui_category_id == 2 ||
                  ui_category_id == 4 ||
                  ui_category_id == 14
                "
              />
              <WordCloud
                :dataset.sync="dataSet"
                v-else-if="ui_category_id == 5"
              />
              <ScatterPlot
                :dataset.sync="dataSet"
                v-else-if="ui_category_id == 6"
              />
              <Boxplot
                :dataset.sync="dataSet"
                v-else-if="ui_category_id == 7"
              />
              <StarRating
                :dataset.sync="dataSet"
                v-else-if="ui_category_id == 8"
              />
              <ImageQues
                :dataset.sync="dataSet"
                v-else-if="ui_category_id == 9"
              />
              <AudioQues
                :dataset.sync="dataSet"
                v-else-if="ui_category_id == 10"
              />
              <VideoQues
                :dataset.sync="dataSet"
                v-else-if="ui_category_id == 11"
              />
              <NodataComponent v-else />
            </v-layout>
          </v-card-text>
        </v-card>
      </v-container>
    </v-flex>
  </v-layout>
</template>

<script ln="ts">
  import axios from "axios";
  import { mapGetters } from "vuex";
  import router from "../../../router";
  import { ROOT_URL } from "@/api/connectingUrls";
  import FreqTblPieBar from "./FrequencyTablewithPieBar.vue";
  import ScatterPlot from "./RangeScatterPlotGraph.vue";
  import Boxplot from "./SliderBoxplotGraph.vue";
  import StarRating from "./StarRating.vue";
  import WordCloud from "./WordCloudOpenended.vue";
  import ImageQues from "./ImageResponseReport.vue";
  import AudioQues from "./AudioResponseReport.vue";
  import VideoQues from "./VideoResponseReport.vue";
  import NodataComponent from "./NodataComponent.vue";

  export default {
    components: {
      FreqTblPieBar,
      ScatterPlot,
      Boxplot,
      StarRating,
      NodataComponent,
      WordCloud,
      ImageQues,
      AudioQues,
      VideoQues,
    },
    data: () => ({
      question_id: null,
      ui_category_id: null,
      dataSet: [{}],
    }),

    computed: {
      ...mapGetters(["indexData", "error", "statusCode", "errorMsg"]),
    },

    created() {
      this.initialize();
    },

    methods: {
      initialize() {
        this.ui_category_id = null;
      },
      async getComponent(projectId, quesId, queTypeId) {
        let postData = {
          project_id: projectId,
          question_id: quesId,
          ui_category_id: queTypeId,
        };
        try {
          const token = window.localStorage.getItem("datadash_token");
          if (token != null) {
            return axios
              .post(`${ROOT_URL}/${"response-report"}`, postData, {
                headers: {
                  Authorization: `Bearer ${token}`,
                  "Content-Type": "application/json",
                },
              })
              .then((response) => {
                if (response.data.statusCode == 200) {
                  this.ui_category_id = queTypeId;
                  this.dataSet = response.data.response;
                  // console.log(response);
                }
              });
          }
        } catch (error) {
          // console.log(error);
        }
      },
      back() {
        router.push("/task-status");
      },
    },
  };
</script>
<style scoped>
  .scrollable {
    height: 500px; /* or any height you want */
    overflow-y: auto;
  }
</style>
